import * as _ from "lodash";
import ColumnObject from "api/lib/data/interfaces/ColumnObject";
import * as React from "react";
import { Header, Icon, Input, List, Popup, Segment } from "semantic-ui-react";
import { Base, IBaseProps, IBaseState } from "../Common/Base";
import DataType from "api/lib/abstract_query/interfaces/DataType";
import ResultColumn from "api/lib/abstract_query/interfaces/ResultColumn";
import ResultColumnFactory from "api/lib/abstract_query/ResultColumnFactory";
import Column from "api/lib/abstract_query/interfaces/Column";

export interface IBrowseColumnsProps extends IBaseProps {
  metadata: any;
  orgId: string;
  resultColumns: ResultColumn[];
  addColumn: (tableName: string, column: ColumnObject, metadata: any) => void;
  hideSchema: () => void;
}

export interface IBrowseColumnsState extends IBaseState {
  selectedItem: any;
  metadata: any;
  tables: any;
}

export default class BrowseColumns extends Base<
  IBrowseColumnsProps,
  IBrowseColumnsState
> {
  private static INITIAL_STATE: IBrowseColumnsState = {
    listeners: [],
    metadata: {
      tables: {},
    },
    tables: {},
    selectedItem: {},
  };
  constructor(props: IBrowseColumnsProps) {
    super(props);

    this.state = { ...BrowseColumns.INITIAL_STATE };
  }
  offset = [10000, 10];
  public render() {
    return (
      <Segment style={{ height: `100%`, padding: "0" }}>
        {this.renderDropdownContent()}
      </Segment>
    );
  }
  public componentDidMount = () => {
    this.getData(this.props.metadata);
  };

  public componentDidUpdate = (prevProps) => {
    if (this.props.metadata !== prevProps.metadata) {
      this.getData(this.props.metadata);
    }
  };

  private getData = (metadata: any) => {
    this.setState({ metadata }, () => {
      this.getFilteredData("");
    });
  };

  private renderDropdownContent = () => {
    const { tables } = this.state;
    const { hideSchema } = this.props;
    return (
      <React.Fragment>
        <Header>Schema </Header>
        {hideSchema && (
          <Popup
            content="Close schema"
            position="bottom left"
            trigger={
              <Icon
                link={true}
                style={{
                  position: "absolute",
                  top: "0",
                  right: "0",
                  zIndex: "12",
                }}
                name="close"
                onClick={hideSchema}
              />
            }
          />
        )}
        <Input
          icon="search"
          iconPosition="left"
          name="search"
          // focus={true}
          onClick={(e: React.BaseSyntheticEvent) => e.stopPropagation()}
          onChange={this.handleSearchInputChange}
          placeholder="Search columns"
          style={{ width: "100%", padding: "10px 0" }}
        />

        <List
          verticalAlign="middle"
          className="schema-browser"
          style={{
            height: "calc(100% - 58px)",
          }}
        >
          {tables &&
            Object.keys(tables).map((tableName: string) => {
              const columns = tables[tableName].columns;
              return (
                <List.Item key={tableName}>
                  <List.Header>{tableName}</List.Header>
                  <List selection={true}>
                    {Object.keys(columns).map((columnName) => {
                      return (
                        <List.Item
                          disabled={this.isAlreadyResultColumn(
                            tableName,
                            columnName
                          )}
                          key={columnName}
                          onClick={() => {
                            this.handleDropdownItemClicked(
                              tableName,
                              columnName,
                              columns[columnName]
                            );
                          }}
                        >
                          {this.getColumnIcon(columns[columnName])}
                          <List.Content>{columnName}</List.Content>
                        </List.Item>
                      );
                    })}
                  </List>
                </List.Item>
              );
            })}
        </List>
      </React.Fragment>
    );
  };
  private handleDropdownItemClicked = (
    tableName: string,
    columnName: string,
    column: ColumnObject
  ) => {
    column.name = columnName;
    this.props.addColumn(tableName, column, this.state.metadata);
  };

  private handleSearchInputChange = (
    e: React.SyntheticEvent,
    { value }: any
  ) => {
    this.getFilteredData(value);
  };

  private getFilteredData = (searchString: string) => {
    const { metadata } = this.state;
    let filteredData = {};
    if (_.isEmpty(searchString)) {
      filteredData = metadata.tables;
    } else {
      filteredData = this.filterTree(searchString, metadata.tables);
    }
    this.setState({ tables: filteredData });
  };

  private filterTree = (filter, list) => {
    const tables = JSON.parse(JSON.stringify(list));
    const newTables = {};
    Object.keys(tables).forEach((tableName: string) => {
      const columns = tables[tableName].columns;
      const newColumns = {};
      Object.keys(columns).map((columnName: string) => {
        if (_.toLower(columnName).includes(_.toLower(filter))) {
          newColumns[columnName] = columns[columnName];
        }
      });
      if (Object.keys(newColumns).length > 0) {
        newTables[tableName] = tables[tableName];
        newTables[tableName].columns = newColumns;
      }
    });
    return newTables;
  };

  private isAlreadyResultColumn = (tableName, columnName): boolean => {
    const fRS: ResultColumn[] = _.filter(
      this.props.resultColumns,
      (resultColumn) => {
        const col: Column = ResultColumnFactory.getColumn(resultColumn);
        return col.table === tableName && col.name === columnName;
      }
    );
    return fRS !== undefined && fRS.length > 0;
  };

  private getColumnIcon = (resultColumn: ColumnObject) => {
    if (resultColumn.type === "metric") {
      return <Icon name="hashtag" className="metric" style={{ top: "0" }} />;
    } else {
      if (
        [
          DataType.DATE,
          DataType.DATETIME,
          DataType.TIME,
          DataType.TIMESTAMP,
          DataType.TIMESTAMPWITHTIMEZONE,
          DataType.TIMEWITHTIMEZONE,
        ].indexOf(resultColumn.dataType) >= 0
      ) {
        return (
          <Icon
            name="calendar alternate outline"
            className="dimension date"
            style={{ top: "0" }}
          />
        );
      } else {
        return <Icon name="font" className="dimension" style={{ top: "0" }} />;
      }
    }
  };

  // private handleOpen = (evt: React.SyntheticEvent, data: object) => {};
}



// WEBPACK FOOTER //
// ./src/components/Query/BrowseColumns.tsx